export class RouterPortConfiguration {
    port: number;
    label: string;
    comments: string;
    untaggedLogicalNetworkId: number;
    taggedLogicalNetworkIds: number[];
    mode: boolean; // 'default' on true, 'custom' on false
}
